import { Pipe, PipeTransform } from '@angular/core';
import { orderBy } from 'lodash';

type LodashSortOrder = 'asc' | 'desc';

@Pipe({
  name: 'orderBy',
  standalone: true,
})
export class OrderByPipe implements PipeTransform {
  transform(array: any, sortBy: string, order?: LodashSortOrder): any[] {
    const sortOrder = order ? order : 'asc';

    return orderBy(array, [sortBy], [sortOrder]);
  }
}
